import React, { Component  } from 'react';
import { inject, observer } from 'mobx-react';
import TenantLoginForm from '../tenantLoginForm/tenantForm'
import LoginForm from '../loginForm';
import TwoFactorForm from '../twoFALoginForm';
import RecoveryCodeForm from '../recoveryCodeForm';
import PasswordExpiredForm from '../passwordExpired'
import LinkContainer from '../userLoginForm/links';
import UnauthorizedErrorContainer from '../unauthorizedIPError';

@inject('authStore', 'configurationsStore', 'authenticationProvidersStore', 'adminConfigurationStore', 'loginSettingsStore') @observer
export default class loginOptions extends Component {

    componentWillMount() {
        const { isMultitenancyMode } = this.props.configurationsStore;
        const { loginSteps } = this.props.authStore;
        const { displayForgotPasswordLink } = this.props.adminConfigurationStore;
        const { loginSettings } = this.props.loginSettingsStore;

        if (this.props.authStore.loginCurrentStep == undefined) {
            this.props.authStore.setLoginStep(loginSteps.tenantForm);
        }
        if (!isMultitenancyMode && this.props.authStore.loginCurrentStep == loginSteps.tenantForm) {
            this.props.adminConfigurationStore.getForgotPasswordSetting();
            this.props.authStore.setLoginStep(loginSteps.passwordForm);
        }

        if (this.props.authenticationProvidersStore.authenticationProviders == undefined && this.props.authStore.loginCurrentStep != loginSteps.tenantForm) {
            if (!isMultitenancyMode) {
                const Auths = this.props.authenticationProvidersStore.getAllAuthenticationProviders().then(response => {
                    return response;
                });
            }
            else {
                const Auths = this.props.authenticationProvidersStore.getAllAuthenticationProvidersOfTenant().then(response => {
                    return response;
                });
            }
        }

        if(this.loginSettings == undefined ){
            this.loginSettings = this.props.loginSettingsStore.getDefaultLoginMethod();
        }
    }

    render() {
        const { loginSteps, values } = this.props.authStore;
        const { isMultitenancyMode } = this.props.configurationsStore;
        const { displayForgotPasswordLink } = this.props.adminConfigurationStore;

        if (this.props.authStore.loginCurrentStep == loginSteps.tenantForm)
            return (<TenantLoginForm returnUrl={this.props.returnUrl} />);

        else {
            if (this.props.authenticationProvidersStore.isIpAuthorized == true) {
                switch (this.props.authStore.loginCurrentStep) {
                    case loginSteps.passwordForm:
                        let tenantHeader = isMultitenancyMode ? <div className='tenant-header'>Account: {values.tenant} </div> : null;
                        return (
                            <div className='user-login-form' data-cy='user-login-form'>{tenantHeader}< LoginForm returnUrl={this.props.returnUrl} /><LinkContainer displayForgotPasswordLink={displayForgotPasswordLink} /></div >
                        )
                    case loginSteps.twoFAForm:
                        return (
                            <TwoFactorForm returnUrl={this.props.returnUrl} />
                        )
                    case loginSteps.recoveryCodeForm:
                        return (
                            <RecoveryCodeForm returnUrl={this.props.returnUrl} />
                        )
                    case loginSteps.passwordExpired:
                        return (<PasswordExpiredForm returnUrl={this.props.returnUrl} />)

                }
            }
            else if (this.props.authenticationProvidersStore.isIpAuthorized == false) {
                return (
                    <div className='user-login-form' data-cy='user-login-form'><UnauthorizedErrorContainer /><div><LinkContainer /></div></div>)
            }
            else {
                return null
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/account/loginOptions/loginOptions.jsx